<template>
  <div v-if="$route.path !== '/home'">
    <div>
      <header id="topHeader" style="transform: translateY(0%)"
        class="w-[calc(100%-20px)] fixed left-0 top-0 bg-[#fff] z-[999] border-b-[1px] border-[#EFEFEF] animation">
        <div class="h-[60px] w-[1200px] flex justify-between items-center mx-[auto]">
          <div class=" flex">
            <div class="text-xl text-black cursor-pointer flex items-center font-bold mr-[35px] logo">
              <img src="@/assets/img/logo.png" alt="logo" class="h-[35px] w-[55px] object-contain" />
            </div>
            <Header ref="routerHeader" :has-token="$store.state.user.token" :is-pro="$store.state.app.is_pro_env" />
          </div>
          <HeaderInfoControlVue />
        </div>
      </header>
    </div>
    <div class="flex">
      <div :key="$store.state.app.render" v-infinite-scroll="reachBottom" infinite-scroll-immediate="false"
        :infinite-scroll-distance="1" class="flex-1 bg-[#ffffff] pt-[60px] overflow-y-auto" style="height: 100vh;"
        id="globalScroll">
        <router-view v-wechat-title="$route.meta.title" />
      </div>
    </div>
  </div>
  <router-view v-else v-wechat-title="$route.meta.title" />
</template>

<script>
import { mapGetters } from 'vuex'
import Header from './header.vue'
import { getEnv, } from '@/api/user'
import { getToken } from '@/utils/auth' // get token from cookie
import HeaderInfoControlVue from '../components/headerInfoControl.vue'
import { isMobile } from '@/utils/common'

export default {
  components: { Header, HeaderInfoControlVue },
  data() {
    return {
      logo: '',
      urlOrigin: location.origin,
    }
  },
  computed: {
    ...mapGetters(['avatar', 'name', 'auth', 'uid', 'username']),
  },
  mounted() {
    // 监听页面的窗口的变化，每次窗口变化调用等比例缩放方法
    // window.addEventListener('resize', this.bodyScale, false)
    this.$store.state.user.token = getToken()
    this.getEnvEvent() // 获取是否为正式环境
    if (getToken()) {
      // this.__canvasWM({
      //   content: `${this.name ?? ''} ${this.username ?? ''}`,
      // })
      this.$store.dispatch("user/heartbreak")
    }
  },

  methods: {
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$store.state.user.token = getToken()
      this.$store.state.app.render = !this.$store.state.app.render;
    },
    reachBottom(v) {
      console.log('reachBottom', { time: Date.now() });
      this.$store.dispatch('app/setReachBottomInfo', { time: Date.now() })
    },
    getEnvEvent() {
      getEnv().then((res) => {
        if (res?.code === 200) {
          this.$store.state.app.is_pro_env = res?.data?.is_pro_env ?? false
        }
      })
    },

    // 等比例缩放的方法，可以放到VUE的method里
    bodyScale() {
      var deviceWidth = document.documentElement.clientWidth //获取当前分辨率下的可是区域宽度
      var scale = deviceWidth / 2560 // 分母——设计稿的尺寸
      document.documentElement.style.zoom = scale //放大缩小相应倍数
    },

    __canvasWM({
      container = document.body,
      width = '275px',
      height = '268px',
      textAlign = 'center',
      textBaseline = 'middle',
      font = '16px',
      fillStyle = 'rgba(0, 0, 0, 0.05)',
      content = '',
      rotate = -45,
      zIndex = 10000,
    } = {}) {
      const args = arguments[0]
      const canvas = document.createElement('canvas')

      canvas.setAttribute('width', width)
      canvas.setAttribute('height', height)
      const ctx = canvas.getContext('2d')

      ctx.textAlign = textAlign
      ctx.textBaseline = textBaseline
      ctx.font = font
      ctx.fillStyle = fillStyle
      ctx.translate(parseFloat(width) / 2, parseFloat(height) / 2)
      ctx.rotate((rotate * Math.PI) / 180)
      ctx.fillText(content, 0, 0)

      const base64Url = canvas.toDataURL()
      const __wm = document.querySelector('.__wm')

      const watermarkDiv = __wm || document.createElement('div')
      const styleStr = `
                  position:fixed;
                  top:0;
                  left:0;
                  bottom:0;
                  right:0;
                  width:100%;
                  height:100%;
                  z-index:${zIndex};
                  pointer-events:none;
                  background-image:url('${base64Url}')`

      watermarkDiv.setAttribute('style', styleStr)
      watermarkDiv.classList.add('__wm')

      if (!__wm) {
        container.insertBefore(watermarkDiv, container.firstChild)
      }

      if (typeof module != 'undefined' && module.exports) {
        //CMD
        module.exports = this.__canvasWM
      } else if (typeof define == 'function' && define.amd) {
        // AMD
        define(function () {
          return this.__canvasWM
        })
      } else {
        window.__canvasWM = this.__canvasWM
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.logo {
  // left: calc((50vw - 700px) * 0.3);
  // top: 0;
  display: flex;
  justify-content: center;
  height: 100%;
}

.animation {
  transition: transform 0.2s ease-out
}

#globalScroll {
  &::-webkit-scrollbar-track {
    background-color: #ddd;
    box-shadow: none;
  }
}
</style>
